import { z } from 'zod';

/** Shareable onboarding URLs: `?returnUrl=` / `?return=` (EU-75). */
export const onboardingLayoutSearchSchema = z.object({
  returnUrl: z.string().optional().catch(undefined),
  return: z.string().optional().catch(undefined),
});

export type OnboardingLayoutSearch = z.infer<typeof onboardingLayoutSearchSchema>;
